"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemChecked = void 0;
var _react = _interopRequireDefault(require("react"));
var _Check = _interopRequireDefault(require("@mui/icons-material/Check"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MenuItemChecked = _ref => {
  let {
    onClick,
    optionLabel,
    checked
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    onClick: onClick
  }, checked ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.ListItemIcon, null, /*#__PURE__*/_react.default.createElement(_Check.default, null)), optionLabel) : /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
    inset: true
  }, optionLabel));
};
exports.MenuItemChecked = MenuItemChecked;